module.exports = __webpack_public_path__ + "static/media/Support_Center.ab27a420.svg";